interface IanyFun {
    (...args: any[]): any;
}

export class Event {
    constructor() {
        this.events = {};
    }

    private events: { [k: string]: IanyFun[] };
    add(name: string, fn: IanyFun) {
        if (!fn) return () => {};
        const hooks = this.get(name);
        hooks.push(fn);
        this.events[name] = hooks;

        return () => this.off(name, fn);
    }

    on(name: string, fn: IanyFun) {
        return this.add(name, fn);
    }

    once(name: string, fn: IanyFun) {
        const off = this.add(name, (...args) => {
            off();
            fn(...args);
        });
        return off;
    }

    off(name: string, fn: IanyFun) {
        const hooks = this.get(name);
        if (hooks) {
            const index = hooks.findIndex((f) => f === fn);
            index !== -1 && hooks.splice(index, 1);
        }
    }

    get(name: string) {
        return this.events[name] || [];
    }

    invoke(name: string, ...args: any[]) {
        const evnets = [...this.get(name)];
        for (const hook of evnets) {
            hook(...args);
        }
    }

    emit(name: string, ...args: any[]) {
        this.invoke(name, ...args);
    }

    async asyncInvoke(name: string, ...args: any[]) {
        const evnets = [...this.get(name)];

        for (const hook of evnets) {
            await hook(...args);
        }
    }

    async asyncInvokeAll(name: string, ...args: any[]) {
        await Promise.all(this.get(name).map((hook) => hook(...args)));
    }
}
